var map = {
	"./baby-notebook__box-d-day--Twins01.png": 40776,
	"./baby-notebook__box-d-day--Twins02.png": 93987,
	"./baby-notebook__box-d-day--Twins03.png": 72410,
	"./baby-notebook__box-d-day--Twins04.png": 30357,
	"./baby-notebook__box-d-day--Twins05.png": 63820,
	"./baby-notebook__box-d-day--Twins06.png": 32295,
	"./baby-notebook__box-d-day--Twins07.png": 44606,
	"./baby-notebook__box-d-day--Twins08.png": 43497,
	"./baby-notebook__box-d-day--Twins09.png": 88672,
	"./baby-notebook__box-d-day--Twins10.png": 39030
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16606;